import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { armReturnEnforcement, markBackNavigation } from "./navigationMemory";
import { resolveSmartBackDecision } from "./smartBackNavigation";

/**
 * Returns to the page that opened this one.
 * Uses the in-app stack (pathname + search + hash), not `history.go(-1)`,
 * so a system-back trap or a redirect hop cannot skip to Arena or Profile.
 * Cold entry (no prior page) uses `fallbackPath`.
 * Wired through `ProfileDashboardHeader`, `PlatformPageShell`, and `useBackNavigation`.
 *
 * @param {string} [fallbackPath="/"]
 */
export function useNavigateBack(fallbackPath = "/") {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    const decision = resolveSmartBackDecision(location, fallbackPath);
    const target = decision.target || fallbackPath || "/";

    if (decision.mode !== "fallback") {
      markBackNavigation();
    }
    armReturnEnforcement(target);
    navigate(target, { replace: true });
  }, [navigate, location, fallbackPath]);
}

/** Alias — canonical name for product/docs. */
export const useSmartBack = useNavigateBack;
